import {Component, OnInit} from '@angular/core';
import {DialogComponent, DialogService} from 'ng2-bootstrap-modal';
import 'rxjs/add/operator/switchMap';
import {UtilsService} from '../services/utils.service';
import {TranslateService} from '@ngx-translate/core';

export interface GenericModalModel {
  title: string;
  data: any;
}

@Component({
  selector: 'app-generic-modal',
  templateUrl: './generic-modal.component.html',
  styleUrls: ['./generic-modal.component.css']
})
export class GenericModalComponent extends DialogComponent<GenericModalModel, boolean> implements OnInit {
  title: string;
  data: any;

  constructor(dialogService: DialogService, private utilsService: UtilsService, private translate: TranslateService) {
    super(dialogService);
  }

  ngOnInit() {
    document.getElementsByTagName('body')[0].classList.add('modal-open');
    if (this.data.message) {
        this.data.message = this.utilsService.decodeHtml(this.data.message);
    } else {
        this.data.message = 'There was an unexpected error.'
            + ' Please try again or contact <a href="mailto:support@openlm.com">support@openlm.com</a> if error persists.';
    }
  }

  ok() {
    this.result = true;
    this.close();
  }

  cancel() {
      this.result = false;
      this.close();
  }

}



// WEBPACK FOOTER //
// C:/Work/Projects/OnlineParser/web2-ui/src/app/generic-modal/generic-modal.component.ts